import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { errMsg } from "./mcfUtils";

// Master lists used by the MCF Stock Transfers forms and filters.
export function useMcfLookups() {
  const [warehouses, setWarehouses] = useState([]);
  const [products, setProducts] = useState([]);
  const [pickups, setPickups] = useState([]);
  const [couriers, setCouriers] = useState([]);

  const reloadWarehouses = useCallback(async () => {
    const res = await axios.get(`${API}/warehouses`);
    setWarehouses(res.data || []);
  }, []);
  const reloadPickups = useCallback(async () => setPickups((await axios.get(`${API}/mcf/pickup-locations`)).data.map((x) => x.name)), []);
  const reloadCouriers = useCallback(async () => setCouriers((await axios.get(`${API}/mcf/courier-partners`)).data.map((x) => x.name)), []);

  useEffect(() => {
    reloadWarehouses().catch(() => toast.error("Could not load warehouses"));
    reloadPickups().catch(() => {});
    reloadCouriers().catch(() => {});
    axios.get(`${API}/products`, { params: { page_size: 5000 } })
      .then((r) => setProducts(Array.isArray(r.data) ? r.data : r.data.items || []))
      .catch(() => {});
  }, [reloadWarehouses, reloadPickups, reloadCouriers]);

  const addTo = (url, reload, label) => async (name) => {
    try {
      const res = await axios.post(`${API}/mcf/${url}`, { name });
      await reload();
      toast.success(`${label} "${res.data.name}" added`);
      return res.data.name;
    } catch (err) {
      toast.error(errMsg(err, `Could not add ${label.toLowerCase()}`));
      return null;
    }
  };

  return {
    dropWarehouses: warehouses.filter((w) => w.warehouse_type !== "weekly_allocation"),
    pickupWarehouses: [...warehouses].filter((w) => w.is_active)
      .sort((a, b) => (a.warehouse_type === "weekly_allocation" ? -1 : b.warehouse_type === "weekly_allocation" ? 1 : a.warehouse_name.localeCompare(b.warehouse_name))),
    products,
    pickups,
    couriers,
    reloadWarehouses,
    addPickup: addTo("pickup-locations", reloadPickups, "Pickup location"),
    addCourier: addTo("courier-partners", reloadCouriers, "Courier partner"),
  };
}
